import React, { useState } from "react";

const ChangeEmail = ({
  show,
  onHide,
  formik1,
  setEmailError,
  emailerror,
  checkValidparams,
  formik2,
}) => {
  return (
    <div
      className={`fixed inset-0 flex items-center justify-center signup-otp-verify-wrp ${
        show ? "" : "d-none"
      }`}
    >
      {/* Background Overlay */}
      <div className="fixed inset-0 bg-gray-900 opacity-50"></div>

      {/* Modal Content */}
      <form
        className="bg-white rounded-lg p-8 max-w-md w-full z-50 shadow-lg mx-2 signup-otp-verify-content"
        onSubmit={() => {
          onHide();
          formik2.handleSubmit();
        }}
      >
        {/* Modal Header */}
        <h2 className="text-xl font-semibold mb-4 text-center">Update Email</h2>
        <div className="col-xxl-12  col-md-12">
          <div className="input-form">
            {/* <label>Email</label> */}
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              maxLength={150}
              autoComplete="new-email"
              value={formik1.values.email}
              onChange={(e) => {
                formik1.setFieldValue("email", e.target.value);
                setEmailError("");
              }}
              onBlur={(e) => {
                checkValidparams("email");
                formik1.handleBlur(e);
              }}
            />
            {formik1.touched.email && formik1.errors.email ? (
              <div className="error">{formik1.errors.email}</div>
            ) : (
              emailerror !== "" && <div className="error">{emailerror}</div>
            )}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mt-4 d-flex align-items-center justify-content-center gap-3">
          <button className="cmn-btn">Submit</button>
          <button
            className="cmn-btn signup-otp-verify-cancel"
            onClick={() => {
              onHide();
            }}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default ChangeEmail;
